export default {"src":"/_next/static/media/weather-working-2.081c26d6.svg","height":477,"width":460,"blurWidth":0,"blurHeight":0};